import { render } from "./TaskList.vue?vue&type=template&id=13757d09"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
script.render = render

export default script